import { post } from 'aws-amplify/api';

/**
 * Set up the current user as a Customer:User.
 * Synchronous — creates QBO Customer and returns qboCustomerId.
 */
export async function setupUserCustomer() {
    const payload = {
        apiName: 'CustomerSetupApi',
        path: 'customer_setup/user',
        options: {
            body: {}
        }
    };
    const restOperation = post(payload);
    const { body } = await restOperation.response;
    return await body.json();
}

/**
 * Set up an Organization as a Customer:Organization.
 * Synchronous — creates QBO Customer and returns qboCustomerId.
 *
 * @param {string} orgName - Organization name
 * @param {string|null} orgID - Existing org ID (null to create new)
 * @param {string} orgEmail - Contact email for the org (required for billing)
 */
export async function setupOrgCustomer({ orgName, orgID = null, orgEmail }) {
    const requestBody = { orgName };
    if (orgID) requestBody.orgID = orgID;
    requestBody.orgEmail = orgEmail;

    const payload = {
        apiName: 'CustomerSetupApi',
        path: 'customer_setup/org',
        options: {
            body: requestBody
        }
    };
    const restOperation = post(payload);
    const { body } = await restOperation.response;
    return await body.json();
}

/**
 * Store a payment method token for a Customer.
 * Called after the Intuit hosted iframe returns a one-time token.
 *
 * @param {string} customerID - The Customer's customerID
 * @param {string} paymentToken - One-time token from Intuit iframe
 * @param {string} tokenType - "CreditCard" or "BankAccount"
 * @param {string} recaptchaToken - reCAPTCHA token
 */
export async function storePaymentMethod({ customerID, paymentToken, tokenType = "CreditCard", recaptchaToken }) {
    const payload = {
        apiName: 'CustomerSetupApi',
        path: 'customer_setup/payment',
        options: {
            body: {
                customerID,
                paymentToken,
                tokenType,
                recaptchaToken
            }
        }
    };
    const restOperation = post(payload);
    const { body } = await restOperation.response;
    return await body.json();
}